module.exports = fox._r("images/social1.png", __webpack_public_path__ + "images/social1.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/social1.png
// module id = 1122
// module chunks = 4